/**
 * Transflo.WorkflowDefinition.HttpApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { ActionResponse } from '../model/action-response';
// @ts-ignore
import { ErrorResponse } from '../model/error-response';
// @ts-ignore
import { ReorderActionRequest } from '../model/reorder-action-request';
// @ts-ignore
import { ReorderSegmentRequest } from '../model/reorder-segment-request';
// @ts-ignore
import { ReorderSegmentResponse } from '../model/reorder-segment-response';
// @ts-ignore
import { ReorderStepRequest } from '../model/reorder-step-request';
// @ts-ignore
import { ReorderStepResponse } from '../model/reorder-step-response';
// @ts-ignore
import { SaveActionRequest } from '../model/save-action-request';
// @ts-ignore
import { SaveBlockersRequest } from '../model/save-blockers-request';
// @ts-ignore
import { SaveConditionalsRequest } from '../model/save-conditionals-request';
// @ts-ignore
import { SaveSegmentRequest } from '../model/save-segment-request';
// @ts-ignore
import { SaveStepRequest } from '../model/save-step-request';
// @ts-ignore
import { SaveTriggerRequest } from '../model/save-trigger-request';
// @ts-ignore
import { SegmentResponse } from '../model/segment-response';
// @ts-ignore
import { StepResponse } from '../model/step-response';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import {
    SaveServiceInterface
} from './save.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class SaveService implements SaveServiceInterface {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
            if (firstBasePath != undefined) {
                basePath = firstBasePath;
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Set and update blockers for segments
     * @param workflowId 
     * @param segmentRefId 
     * @param saveBlockersRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdBlockersPut(workflowId: number, segmentRefId: number, saveBlockersRequest?: SaveBlockersRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdBlockersPut(workflowId: number, segmentRefId: number, saveBlockersRequest?: SaveBlockersRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdBlockersPut(workflowId: number, segmentRefId: number, saveBlockersRequest?: SaveBlockersRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdBlockersPut(workflowId: number, segmentRefId: number, saveBlockersRequest?: SaveBlockersRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (workflowId === null || workflowId === undefined) {
            throw new Error('Required parameter workflowId was null or undefined when calling apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdBlockersPut.');
        }
        if (segmentRefId === null || segmentRefId === undefined) {
            throw new Error('Required parameter segmentRefId was null or undefined when calling apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdBlockersPut.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (TransfloAuth) required
        localVarCredential = this.configuration.lookupCredential('TransfloAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/Workflow/${this.configuration.encodeParam({name: "workflowId", value: workflowId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/Save/segment/${this.configuration.encodeParam({name: "segmentRefId", value: segmentRefId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/blockers`;
        return this.httpClient.request<any>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: saveBlockersRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Set and update conditionals for segments
     * @param workflowId 
     * @param segmentRefId 
     * @param saveConditionalsRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdConditionalsPut(workflowId: number, segmentRefId: number, saveConditionalsRequest?: SaveConditionalsRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdConditionalsPut(workflowId: number, segmentRefId: number, saveConditionalsRequest?: SaveConditionalsRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdConditionalsPut(workflowId: number, segmentRefId: number, saveConditionalsRequest?: SaveConditionalsRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdConditionalsPut(workflowId: number, segmentRefId: number, saveConditionalsRequest?: SaveConditionalsRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (workflowId === null || workflowId === undefined) {
            throw new Error('Required parameter workflowId was null or undefined when calling apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdConditionalsPut.');
        }
        if (segmentRefId === null || segmentRefId === undefined) {
            throw new Error('Required parameter segmentRefId was null or undefined when calling apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdConditionalsPut.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (TransfloAuth) required
        localVarCredential = this.configuration.lookupCredential('TransfloAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/Workflow/${this.configuration.encodeParam({name: "workflowId", value: workflowId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/Save/segment/${this.configuration.encodeParam({name: "segmentRefId", value: segmentRefId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/conditionals`;
        return this.httpClient.request<any>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: saveConditionalsRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Add or Update Segment
     * @param workflowId The Workflow ID.
     * @param segmentRefId Must check \&quot;Send empty value\&quot; or Swagger passes a comma for empty values otherwise
     * @param saveSegmentRequest The segment data to upsert.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdPut(workflowId: number, segmentRefId?: number, saveSegmentRequest?: SaveSegmentRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SegmentResponse>;
    public apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdPut(workflowId: number, segmentRefId?: number, saveSegmentRequest?: SaveSegmentRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SegmentResponse>>;
    public apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdPut(workflowId: number, segmentRefId?: number, saveSegmentRequest?: SaveSegmentRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SegmentResponse>>;
    public apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdPut(workflowId: number, segmentRefId?: number, saveSegmentRequest?: SaveSegmentRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (workflowId === null || workflowId === undefined) {
            throw new Error('Required parameter workflowId was null or undefined when calling apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdPut.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (TransfloAuth) required
        localVarCredential = this.configuration.lookupCredential('TransfloAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/Workflow/${this.configuration.encodeParam({name: "workflowId", value: workflowId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/Save/segment/${this.configuration.encodeParam({name: "segmentRefId", value: segmentRefId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        return this.httpClient.request<SegmentResponse>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: saveSegmentRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Reorder Segment
     * @param workflowId The Workflow ID.
     * @param segmentRefId The Segment Reference ID.
     * @param reorderSegmentRequest The new order for the segment.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdReorderPut(workflowId: number, segmentRefId: number, reorderSegmentRequest?: ReorderSegmentRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ReorderSegmentResponse>;
    public apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdReorderPut(workflowId: number, segmentRefId: number, reorderSegmentRequest?: ReorderSegmentRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ReorderSegmentResponse>>;
    public apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdReorderPut(workflowId: number, segmentRefId: number, reorderSegmentRequest?: ReorderSegmentRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ReorderSegmentResponse>>;
    public apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdReorderPut(workflowId: number, segmentRefId: number, reorderSegmentRequest?: ReorderSegmentRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (workflowId === null || workflowId === undefined) {
            throw new Error('Required parameter workflowId was null or undefined when calling apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdReorderPut.');
        }
        if (segmentRefId === null || segmentRefId === undefined) {
            throw new Error('Required parameter segmentRefId was null or undefined when calling apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdReorderPut.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (TransfloAuth) required
        localVarCredential = this.configuration.lookupCredential('TransfloAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/Workflow/${this.configuration.encodeParam({name: "workflowId", value: workflowId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/Save/segment/${this.configuration.encodeParam({name: "segmentRefId", value: segmentRefId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/reorder`;
        return this.httpClient.request<ReorderSegmentResponse>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: reorderSegmentRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Set and update blockers for steps
     * @param workflowId 
     * @param segmentRefId 
     * @param stepRefId The Step Reference ID.
     * @param saveBlockersRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdStepStepRefIdBlockersPut(workflowId: number, segmentRefId: number, stepRefId: number, saveBlockersRequest?: SaveBlockersRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdStepStepRefIdBlockersPut(workflowId: number, segmentRefId: number, stepRefId: number, saveBlockersRequest?: SaveBlockersRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdStepStepRefIdBlockersPut(workflowId: number, segmentRefId: number, stepRefId: number, saveBlockersRequest?: SaveBlockersRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdStepStepRefIdBlockersPut(workflowId: number, segmentRefId: number, stepRefId: number, saveBlockersRequest?: SaveBlockersRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (workflowId === null || workflowId === undefined) {
            throw new Error('Required parameter workflowId was null or undefined when calling apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdStepStepRefIdBlockersPut.');
        }
        if (segmentRefId === null || segmentRefId === undefined) {
            throw new Error('Required parameter segmentRefId was null or undefined when calling apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdStepStepRefIdBlockersPut.');
        }
        if (stepRefId === null || stepRefId === undefined) {
            throw new Error('Required parameter stepRefId was null or undefined when calling apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdStepStepRefIdBlockersPut.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (TransfloAuth) required
        localVarCredential = this.configuration.lookupCredential('TransfloAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/Workflow/${this.configuration.encodeParam({name: "workflowId", value: workflowId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/Save/segment/${this.configuration.encodeParam({name: "segmentRefId", value: segmentRefId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/step/${this.configuration.encodeParam({name: "stepRefId", value: stepRefId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/blockers`;
        return this.httpClient.request<any>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: saveBlockersRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Set and update conditionals for steps
     * @param workflowId 
     * @param segmentRefId 
     * @param stepRefId The Step Reference ID.
     * @param saveConditionalsRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdStepStepRefIdConditionalsPut(workflowId: number, segmentRefId: number, stepRefId: number, saveConditionalsRequest?: SaveConditionalsRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdStepStepRefIdConditionalsPut(workflowId: number, segmentRefId: number, stepRefId: number, saveConditionalsRequest?: SaveConditionalsRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdStepStepRefIdConditionalsPut(workflowId: number, segmentRefId: number, stepRefId: number, saveConditionalsRequest?: SaveConditionalsRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdStepStepRefIdConditionalsPut(workflowId: number, segmentRefId: number, stepRefId: number, saveConditionalsRequest?: SaveConditionalsRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (workflowId === null || workflowId === undefined) {
            throw new Error('Required parameter workflowId was null or undefined when calling apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdStepStepRefIdConditionalsPut.');
        }
        if (segmentRefId === null || segmentRefId === undefined) {
            throw new Error('Required parameter segmentRefId was null or undefined when calling apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdStepStepRefIdConditionalsPut.');
        }
        if (stepRefId === null || stepRefId === undefined) {
            throw new Error('Required parameter stepRefId was null or undefined when calling apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdStepStepRefIdConditionalsPut.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (TransfloAuth) required
        localVarCredential = this.configuration.lookupCredential('TransfloAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/Workflow/${this.configuration.encodeParam({name: "workflowId", value: workflowId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/Save/segment/${this.configuration.encodeParam({name: "segmentRefId", value: segmentRefId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/step/${this.configuration.encodeParam({name: "stepRefId", value: stepRefId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/conditionals`;
        return this.httpClient.request<any>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: saveConditionalsRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Add or Update Step
     * @param workflowId The Workflow ID.
     * @param segmentRefId The Segment Refence ID.
     * @param stepRefId Must check \&quot;Send empty value\&quot; or Swagger passes a comma for empty values otherwise
     * @param saveStepRequest The step data to upsert.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdStepStepRefIdPut(workflowId: number, segmentRefId: number, stepRefId?: number, saveStepRequest?: SaveStepRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<StepResponse>;
    public apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdStepStepRefIdPut(workflowId: number, segmentRefId: number, stepRefId?: number, saveStepRequest?: SaveStepRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<StepResponse>>;
    public apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdStepStepRefIdPut(workflowId: number, segmentRefId: number, stepRefId?: number, saveStepRequest?: SaveStepRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<StepResponse>>;
    public apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdStepStepRefIdPut(workflowId: number, segmentRefId: number, stepRefId?: number, saveStepRequest?: SaveStepRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (workflowId === null || workflowId === undefined) {
            throw new Error('Required parameter workflowId was null or undefined when calling apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdStepStepRefIdPut.');
        }
        if (segmentRefId === null || segmentRefId === undefined) {
            throw new Error('Required parameter segmentRefId was null or undefined when calling apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdStepStepRefIdPut.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (TransfloAuth) required
        localVarCredential = this.configuration.lookupCredential('TransfloAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/Workflow/${this.configuration.encodeParam({name: "workflowId", value: workflowId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/Save/segment/${this.configuration.encodeParam({name: "segmentRefId", value: segmentRefId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/step/${this.configuration.encodeParam({name: "stepRefId", value: stepRefId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        return this.httpClient.request<StepResponse>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: saveStepRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Reorder Step
     * @param workflowId The Workflow ID.
     * @param segmentRefId The Segment Reference ID.
     * @param stepRefId The Step Reference ID.
     * @param reorderStepRequest The new order for the step.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdStepStepRefIdReorderPut(workflowId: number, segmentRefId: number, stepRefId: number, reorderStepRequest?: ReorderStepRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ReorderStepResponse>;
    public apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdStepStepRefIdReorderPut(workflowId: number, segmentRefId: number, stepRefId: number, reorderStepRequest?: ReorderStepRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ReorderStepResponse>>;
    public apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdStepStepRefIdReorderPut(workflowId: number, segmentRefId: number, stepRefId: number, reorderStepRequest?: ReorderStepRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ReorderStepResponse>>;
    public apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdStepStepRefIdReorderPut(workflowId: number, segmentRefId: number, stepRefId: number, reorderStepRequest?: ReorderStepRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (workflowId === null || workflowId === undefined) {
            throw new Error('Required parameter workflowId was null or undefined when calling apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdStepStepRefIdReorderPut.');
        }
        if (segmentRefId === null || segmentRefId === undefined) {
            throw new Error('Required parameter segmentRefId was null or undefined when calling apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdStepStepRefIdReorderPut.');
        }
        if (stepRefId === null || stepRefId === undefined) {
            throw new Error('Required parameter stepRefId was null or undefined when calling apiV1WorkflowWorkflowIdSaveSegmentSegmentRefIdStepStepRefIdReorderPut.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (TransfloAuth) required
        localVarCredential = this.configuration.lookupCredential('TransfloAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/Workflow/${this.configuration.encodeParam({name: "workflowId", value: workflowId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/Save/segment/${this.configuration.encodeParam({name: "segmentRefId", value: segmentRefId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/step/${this.configuration.encodeParam({name: "stepRefId", value: stepRefId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/reorder`;
        return this.httpClient.request<ReorderStepResponse>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: reorderStepRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Set and update blockers for actions
     * @param workflowId 
     * @param stepRefId The Step Reference ID.
     * @param actionRefId 
     * @param saveBlockersRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdBlockersPut(workflowId: number, stepRefId: number, actionRefId: number, saveBlockersRequest?: SaveBlockersRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdBlockersPut(workflowId: number, stepRefId: number, actionRefId: number, saveBlockersRequest?: SaveBlockersRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdBlockersPut(workflowId: number, stepRefId: number, actionRefId: number, saveBlockersRequest?: SaveBlockersRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdBlockersPut(workflowId: number, stepRefId: number, actionRefId: number, saveBlockersRequest?: SaveBlockersRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (workflowId === null || workflowId === undefined) {
            throw new Error('Required parameter workflowId was null or undefined when calling apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdBlockersPut.');
        }
        if (stepRefId === null || stepRefId === undefined) {
            throw new Error('Required parameter stepRefId was null or undefined when calling apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdBlockersPut.');
        }
        if (actionRefId === null || actionRefId === undefined) {
            throw new Error('Required parameter actionRefId was null or undefined when calling apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdBlockersPut.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (TransfloAuth) required
        localVarCredential = this.configuration.lookupCredential('TransfloAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/Workflow/${this.configuration.encodeParam({name: "workflowId", value: workflowId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/Save/step/${this.configuration.encodeParam({name: "stepRefId", value: stepRefId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/action/${this.configuration.encodeParam({name: "actionRefId", value: actionRefId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/blockers`;
        return this.httpClient.request<any>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: saveBlockersRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Set and update conditionals for actions
     * @param workflowId 
     * @param stepRefId The Step Reference ID.
     * @param actionRefId 
     * @param saveConditionalsRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdConditionalsPut(workflowId: number, stepRefId: number, actionRefId: number, saveConditionalsRequest?: SaveConditionalsRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdConditionalsPut(workflowId: number, stepRefId: number, actionRefId: number, saveConditionalsRequest?: SaveConditionalsRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdConditionalsPut(workflowId: number, stepRefId: number, actionRefId: number, saveConditionalsRequest?: SaveConditionalsRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdConditionalsPut(workflowId: number, stepRefId: number, actionRefId: number, saveConditionalsRequest?: SaveConditionalsRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (workflowId === null || workflowId === undefined) {
            throw new Error('Required parameter workflowId was null or undefined when calling apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdConditionalsPut.');
        }
        if (stepRefId === null || stepRefId === undefined) {
            throw new Error('Required parameter stepRefId was null or undefined when calling apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdConditionalsPut.');
        }
        if (actionRefId === null || actionRefId === undefined) {
            throw new Error('Required parameter actionRefId was null or undefined when calling apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdConditionalsPut.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (TransfloAuth) required
        localVarCredential = this.configuration.lookupCredential('TransfloAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/Workflow/${this.configuration.encodeParam({name: "workflowId", value: workflowId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/Save/step/${this.configuration.encodeParam({name: "stepRefId", value: stepRefId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/action/${this.configuration.encodeParam({name: "actionRefId", value: actionRefId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/conditionals`;
        return this.httpClient.request<any>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: saveConditionalsRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Add or Update several Action Properties in a single transaction.
     * @param workflowId The Workflow ID.
     * @param stepRefId The Step Reference ID.
     * @param actionRefId The Action Reference ID.
     * @param requestBody One entry per property to upsert.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdPropertiesBatchPut(workflowId: number, stepRefId: number, actionRefId: number, requestBody?: { [key: string]: string | undefined; }, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<{ [key: string]: string | undefined; }>>;
    public apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdPropertiesBatchPut(workflowId: number, stepRefId: number, actionRefId: number, requestBody?: { [key: string]: string | undefined; }, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<{ [key: string]: string | undefined; }>>>;
    public apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdPropertiesBatchPut(workflowId: number, stepRefId: number, actionRefId: number, requestBody?: { [key: string]: string | undefined; }, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<{ [key: string]: string | undefined; }>>>;
    public apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdPropertiesBatchPut(workflowId: number, stepRefId: number, actionRefId: number, requestBody?: { [key: string]: string | undefined; }, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (workflowId === null || workflowId === undefined) {
            throw new Error('Required parameter workflowId was null or undefined when calling apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdPropertiesBatchPut.');
        }
        if (stepRefId === null || stepRefId === undefined) {
            throw new Error('Required parameter stepRefId was null or undefined when calling apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdPropertiesBatchPut.');
        }
        if (actionRefId === null || actionRefId === undefined) {
            throw new Error('Required parameter actionRefId was null or undefined when calling apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdPropertiesBatchPut.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (TransfloAuth) required
        localVarCredential = this.configuration.lookupCredential('TransfloAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/Workflow/${this.configuration.encodeParam({name: "workflowId", value: workflowId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/Save/step/${this.configuration.encodeParam({name: "stepRefId", value: stepRefId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/action/${this.configuration.encodeParam({name: "actionRefId", value: actionRefId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/properties/batch`;
        return this.httpClient.request<Array<{ [key: string]: string | undefined; }>>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: requestBody,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Add or Update Action Property
     * @param workflowId The Workflow ID.
     * @param stepRefId The Step Refence ID.
     * @param actionRefId The Action Reference ID.
     * @param propertyName The property name to update value.
     * @param requestBody The action data to upsert.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdPropertyNamePut(workflowId: number, stepRefId: number, actionRefId: number, propertyName: string, requestBody?: { [key: string]: string | undefined; }, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ActionResponse>;
    public apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdPropertyNamePut(workflowId: number, stepRefId: number, actionRefId: number, propertyName: string, requestBody?: { [key: string]: string | undefined; }, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ActionResponse>>;
    public apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdPropertyNamePut(workflowId: number, stepRefId: number, actionRefId: number, propertyName: string, requestBody?: { [key: string]: string | undefined; }, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ActionResponse>>;
    public apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdPropertyNamePut(workflowId: number, stepRefId: number, actionRefId: number, propertyName: string, requestBody?: { [key: string]: string | undefined; }, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (workflowId === null || workflowId === undefined) {
            throw new Error('Required parameter workflowId was null or undefined when calling apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdPropertyNamePut.');
        }
        if (stepRefId === null || stepRefId === undefined) {
            throw new Error('Required parameter stepRefId was null or undefined when calling apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdPropertyNamePut.');
        }
        if (actionRefId === null || actionRefId === undefined) {
            throw new Error('Required parameter actionRefId was null or undefined when calling apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdPropertyNamePut.');
        }
        if (propertyName === null || propertyName === undefined) {
            throw new Error('Required parameter propertyName was null or undefined when calling apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdPropertyNamePut.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (TransfloAuth) required
        localVarCredential = this.configuration.lookupCredential('TransfloAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/Workflow/${this.configuration.encodeParam({name: "workflowId", value: workflowId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/Save/step/${this.configuration.encodeParam({name: "stepRefId", value: stepRefId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/action/${this.configuration.encodeParam({name: "actionRefId", value: actionRefId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/${this.configuration.encodeParam({name: "propertyName", value: propertyName, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<ActionResponse>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: requestBody,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Add or Update Action
     * @param workflowId The Workflow ID.
     * @param stepRefId The Step Refence ID.
     * @param actionRefId Must check \&quot;Send empty value\&quot; or Swagger passes a comma for empty values otherwise
     * @param saveActionRequest The action data to upsert.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdPut(workflowId: number, stepRefId: number, actionRefId?: number, saveActionRequest?: SaveActionRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ActionResponse>;
    public apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdPut(workflowId: number, stepRefId: number, actionRefId?: number, saveActionRequest?: SaveActionRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ActionResponse>>;
    public apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdPut(workflowId: number, stepRefId: number, actionRefId?: number, saveActionRequest?: SaveActionRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ActionResponse>>;
    public apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdPut(workflowId: number, stepRefId: number, actionRefId?: number, saveActionRequest?: SaveActionRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (workflowId === null || workflowId === undefined) {
            throw new Error('Required parameter workflowId was null or undefined when calling apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdPut.');
        }
        if (stepRefId === null || stepRefId === undefined) {
            throw new Error('Required parameter stepRefId was null or undefined when calling apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdPut.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (TransfloAuth) required
        localVarCredential = this.configuration.lookupCredential('TransfloAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/Workflow/${this.configuration.encodeParam({name: "workflowId", value: workflowId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/Save/step/${this.configuration.encodeParam({name: "stepRefId", value: stepRefId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/action/${this.configuration.encodeParam({name: "actionRefId", value: actionRefId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        return this.httpClient.request<ActionResponse>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: saveActionRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Reorder Action
     * @param workflowId The Workflow ID.
     * @param stepRefId The Step Reference ID.
     * @param actionRefId The Action Reference ID.
     * @param reorderActionRequest The new order for the action.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdReorderPut(workflowId: number, stepRefId: number, actionRefId: number, reorderActionRequest?: ReorderActionRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ActionResponse>;
    public apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdReorderPut(workflowId: number, stepRefId: number, actionRefId: number, reorderActionRequest?: ReorderActionRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ActionResponse>>;
    public apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdReorderPut(workflowId: number, stepRefId: number, actionRefId: number, reorderActionRequest?: ReorderActionRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ActionResponse>>;
    public apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdReorderPut(workflowId: number, stepRefId: number, actionRefId: number, reorderActionRequest?: ReorderActionRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (workflowId === null || workflowId === undefined) {
            throw new Error('Required parameter workflowId was null or undefined when calling apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdReorderPut.');
        }
        if (stepRefId === null || stepRefId === undefined) {
            throw new Error('Required parameter stepRefId was null or undefined when calling apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdReorderPut.');
        }
        if (actionRefId === null || actionRefId === undefined) {
            throw new Error('Required parameter actionRefId was null or undefined when calling apiV1WorkflowWorkflowIdSaveStepStepRefIdActionActionRefIdReorderPut.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (TransfloAuth) required
        localVarCredential = this.configuration.lookupCredential('TransfloAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/Workflow/${this.configuration.encodeParam({name: "workflowId", value: workflowId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/Save/step/${this.configuration.encodeParam({name: "stepRefId", value: stepRefId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/action/${this.configuration.encodeParam({name: "actionRefId", value: actionRefId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/reorder`;
        return this.httpClient.request<ActionResponse>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: reorderActionRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Set and update triggers for workflows
     * @param workflowId 
     * @param saveTriggerRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV1WorkflowWorkflowIdSaveTriggersPut(workflowId: number, saveTriggerRequest?: SaveTriggerRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public apiV1WorkflowWorkflowIdSaveTriggersPut(workflowId: number, saveTriggerRequest?: SaveTriggerRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public apiV1WorkflowWorkflowIdSaveTriggersPut(workflowId: number, saveTriggerRequest?: SaveTriggerRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public apiV1WorkflowWorkflowIdSaveTriggersPut(workflowId: number, saveTriggerRequest?: SaveTriggerRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (workflowId === null || workflowId === undefined) {
            throw new Error('Required parameter workflowId was null or undefined when calling apiV1WorkflowWorkflowIdSaveTriggersPut.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (TransfloAuth) required
        localVarCredential = this.configuration.lookupCredential('TransfloAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/Workflow/${this.configuration.encodeParam({name: "workflowId", value: workflowId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/Save/Triggers`;
        return this.httpClient.request<any>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: saveTriggerRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
